package main.kotlin.app.foodees.web.components.atoms.list

import main.kotlin.app.foodees.web.components.atoms.button.MButtonBaseProps
import main.kotlin.app.foodees.web.components.atoms.icon.mIcon
import main.kotlin.app.foodees.web.components.createStyled
import main.kotlin.app.foodees.web.components.setStyledPropsAndRunHandler
import react.RBuilder
import react.RComponent
import react.RState
import styled.StyledHandler

@JsModule("@material-ui/core/ListItemIcon")
private external val listItemIconModule: dynamic

@Suppress("UnsafeCastFromDynamic")
val listItemIconComponent: RComponent<MButtonBaseProps, RState> = listItemIconModule.default

fun RBuilder.mListItemIcon(
        iconName: String? = null,
        className: String? = null,
        handler: StyledHandler<MButtonBaseProps>? = null) = createStyled(listItemIconComponent) {
    iconName?.let { mIcon(iconName) }
    setStyledPropsAndRunHandler(className, handler)
}
